import { render, staticRenderFns } from "./ProductDetails.html?vue&type=template&id=0fafd4d0&scoped=true&"
import script from "./ProductDetails.ts?vue&type=script&lang=ts&"
export * from "./ProductDetails.ts?vue&type=script&lang=ts&"
import style0 from "./ProductDetails.css?vue&type=style&index=0&id=0fafd4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafd4d0",
  null
  
)

export default component.exports